import React, { Component } from "react";
import { FormGroup, ControlLabel, InputGroup, FormControl } from "react-bootstrap";
import withLoadSave from "../components/LoadSave";
import LoaderPanel from "../components/LoaderPanel";
import LoaderButton from "../components/LoaderButton";
import axios from "axios";
import SaveNavbar from "../components/SaveNavbar";
import { EDFormSection, EDFormBox } from "../components/EDDOM";
import _ from "underscore";
import Select2 from "react-select2-wrapper";
import getvalue from "../utils/getvalue";
import fixTag from "../utils/fixtag";

import "react-select2-wrapper/css/select2.css";

class IntegrationsShopifyEdit extends Component {
  handleSubmit = async event => {
    var isclose = this.props.formClose(event);

    await this.props.save();

    if (isclose) {
      this.goBack();
    }
  }

  goBack = () => {
    this.props.history.push('/integrations/shopify');
  }

  onTagChange = event => {
    this.props.update({[event.target.id]: {$set: _.filter(_.map(getvalue(event), fixTag), t => t)}});
  }

  tagData() {
    if (!this.props.tags)
      return [];
    if (_.isUndefined(this._tags)) {
      this._tags = _.uniq(this.props.tags.concat(this.props.data.addtags).concat(this.props.data.updatetags));
    }
    return this._tags;
  }

  navbarButtons = () => {
    return (
      <LoaderButton
        id="warmup-buttons-dropdown"
        text="Save and Close"
        loadingText="Saving..."
        className="green"
        disabled={this.props.isSaving}
        onClick={this.props.formSubmit.bind(null, true)}
        splitItems={[
          { text: 'Save', onClick: this.props.formSubmit },
          { text: 'Cancel', onClick: this.goBack }
        ]}
      />
    )
  }

  render() {
    return (
      <LoaderPanel isLoading={this.props.isLoading}>
        <SaveNavbar title="Edit Shopify Connection" user={this.props.user} isSaving={this.props.isSaving}
          onBack={this.goBack} buttons={this.navbarButtons()} id={this.props.id}>
          <EDFormSection onSubmit={this.handleSubmit} formRef={this.props.formRef}>
            <EDFormBox>
              <FormGroup>
                <ControlLabel>Shop Name:</ControlLabel>
                <InputGroup style={{marginTop: '10px', width: '500px'}}>
                  <InputGroup.Addon>{'https://'}</InputGroup.Addon>
                  <FormControl readOnly type="text" id="shop" value={this.props.data.name} style={{marginBottom: 0, borderRadius: 'inherit'}}/>
                  <InputGroup.Addon>.myshopify.com</InputGroup.Addon>
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <ControlLabel>Tags to Add to New Users:</ControlLabel>
                <Select2
                  id="addtags"
                  multiple
                  value={this.props.data.addtags}
                  data={this.tagData()}
                  onChange={this.onTagChange}
                  style={{width:'100%'}}
                  options={{
                    tags: true,
                  }}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel>Tags to Add to Updated Users:</ControlLabel>
                <Select2
                  id="updatetags"
                  multiple
                  value={this.props.data.updatetags}
                  data={this.tagData()}
                  onChange={this.onTagChange}
                  style={{width:'100%'}}
                  options={{
                    tags: true,
                  }}
                />
              </FormGroup>
            </EDFormBox>
          </EDFormSection>
        </SaveNavbar>
      </LoaderPanel>
    );
  }
}

export default withLoadSave({
  extend: IntegrationsShopifyEdit,
  initial: [],
  extra: {
    tags: async () => (await axios.get('/api/recenttags')).data,
  },
  get: async ({id}) => (await axios.get('/api/shopifyshops/' + id)).data,
  patch: ({id, data}) => axios.patch('/api/shopifyshops/' + id, data),
});



// WEBPACK FOOTER //
// ./src/containers/IntegrationsShopifyEdit.js